import { FC } from "react";

import { getMetaCount } from "helpers/metaUtils";
import { IMeta } from "store/user/user.types";
import { INavigationItem } from "services/data.service";
import { CountBadge } from "components/common";

interface IParentCountBadgeProps {
  meta: IMeta | null;
  link: INavigationItem;
}

const ParentCountBadge: FC<IParentCountBadgeProps> = ({
  meta,
  link,
}) => {
  if (!link.children) return null;

  const sectionKey = link.link.split("/").filter(part => part.length > 0)[ 0 ] || "";
  const totalCount = link.children.reduce((total: number, child) => {
    if (!child.metaKey) return total;
    const count = getMetaCount(meta, sectionKey, child.metaKey);
    return total + count;
  }, 0);

  return (
    <CountBadge count={ totalCount } />
  );
};

export default ParentCountBadge;
